import React from "react";
import * as styles from "./FooterMain.module.scss";
import RatingFooterLinks from "../RatingFooterLinks/RatingFooterLinks";
import {FooterMenu} from "../FooterMenu/FooterMenu";
import FooterSocials from "../FooterSocials/FooterSocials";
import FooterCopyLine from "../FooterCopyLine/FooterCopyLine";
import EuropeBadge from "../EuropeBadge/EuropeBadge";
import {LogoTextPart} from "../../Header/LogoTextPart";

function FooterMain() {
  return (
    <>
      <footer className={styles.root}>
        <div className={styles.mainPart}>
          <div className={styles.lSide}>
            <div className={styles.footerLogo}>
              <a href="/" className={styles.logo}>
                <LogoTextPart/>
              </a>
              <p className={styles.statement}>
                Your&nbsp;company's operating&nbsp;system
              </p>
            </div>

            <div className={styles.ratingWrap}>
              <RatingFooterLinks/>
            </div>

            <div className={styles.security}>
              <div className={styles.badges}>
                <a href="/security">
                  <img src={"https://images-temp.fibery.io/website-static/common/soc2.svg"} alt={"soc2"}/>
                </a>
                <a href="/security">
                  <img src={"https://images-temp.fibery.io/website-static/common/gdpr.svg"} alt={"gdpr"}/>
                </a>
              </div>
              <p className={styles.text}>
                <a href="/security">Enterprise-level security</a>
              </p>
            </div>
          </div>
          <div className={styles.rSide}>
            <FooterMenu/>
          </div>

          <EuropeBadge />
        </div>
        <div className={styles.bottomPart}>
          <div className={styles.lbSide}>
            <FooterCopyLine/>
          </div>
          <div className={styles.rbSide}>
            <FooterSocials/>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterMain;
